import { slicedToArray as _slicedToArray } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { Box } from '@zillow/constellation';
import React, { useState, useEffect } from 'react';
import B2BFooter from '../B2BFooter/B2BFooter.js';
import B2BMainNav from '../B2BMainNav/B2BMainNav.js';
import B2BSubnav from '../B2BSubnav/B2BSubnav.js';
import B2BUserNav from '../B2BUserNav/B2BUserNav.js';

var B2BLayout = function B2BLayout(props) {
  var children = props.children,
    _props$env = props.env,
    env = _props$env === void 0 ? 'production' : _props$env,
    _props$fromApp = props.fromApp,
    fromApp = _props$fromApp === void 0 ? false : _props$fromApp;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    mobileMenu = _useState2[0],
    setMobileMenu = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isSticky = _useState4[0],
    setIsSticky = _useState4[1];
  useEffect(function () {
    // Bail if sticky is not enabled
    if (!props.sticky) {
      return;
    }
    var onScroll = function onScroll() {
      setIsSticky(window.scrollY > window.innerHeight / 2);
    };
    onScroll();
    window.addEventListener('scroll', onScroll);
    return function () {
      window.removeEventListener('scroll', onScroll);
    };
  }, [props.sticky]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, !fromApp && /*#__PURE__*/React.createElement(Box, {
    sx: Object.assign({
      margin: '0 auto',
      position: 'relative'
    }, props.transparent && !isSticky && {
      position: 'absolute',
      width: '100%',
      left: '50%',
      transform: 'translateX(-50%)',
      zIndex: '$zIndices.modal'
    })
  }, !props.disabled && props.signInLink && /*#__PURE__*/React.createElement(B2BUserNav, {
    redirectParam: props.signInRedirectParam,
    router: props.router,
    transparent: props.transparent && !mobileMenu,
    env: env,
    signInLink: props.signInLink
  }), /*#__PURE__*/React.createElement(B2BMainNav, {
    logo: props.logo,
    disabled: props.disabled,
    transparent: props.transparent && !mobileMenu && !isSticky,
    sticky: isSticky,
    menu: props.menu,
    mobileMenu: mobileMenu,
    setMobileMenu: setMobileMenu,
    primaryCTALabel: props.primaryCTALabel,
    primaryCTALink: props.primaryCTALink,
    secondaryCTALabel: props.secondaryCTALabel,
    secondaryCTALink: props.secondaryCTALink
  }), !props.transparent && (props.subnavPrimaryItem || props.subnavItems) && /*#__PURE__*/React.createElement(B2BSubnav, {
    primaryItem: props.subnavPrimaryItem,
    items: props.subnavItems,
    searchPlaceholder: props.searchPlaceholder,
    searchPrefix: props.searchPrefix
  })), children, /*#__PURE__*/React.createElement(B2BFooter, {
    disabled: fromApp || props.disabled,
    columns: props.footerColumns,
    logo: props.logo
  }));
};
var B2BLayout$1 = B2BLayout;

export { B2BLayout$1 as default };
